import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import styles from "./ViewOptionsPanel.module.scss";

const CollapsibleSection = ({
  title,
  defaultOpen = true,
  headerAction = null,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={styles.section}>
      <button
        type="button"
        className={styles.sectionHeader}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className={styles.sectionHeaderLeft}>
          <span>{title}</span>
          {headerAction}
        </span>
        <FiChevronDown
          size={14}
          className={`${styles.sectionChevron} ${open ? styles.sectionChevronOpen : ""}`}
        />
      </button>
      {open && <div className={styles.sectionBody}>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
